import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('boysenberry_enable_entitlements_check');
	},
};
